import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId/",
)({
  beforeLoad: ({ params }) => {
    redirect({
      to: "/museum/$museumId/bookings",
      params: { museumId: params.museumId },
      throw: true,
    });
  },
});
